import { Flex, Image, Text } from "@mantine/core";

import loaderGif from "/loader.gif";

export const LoadingMessage = () => {
  return (
    <Flex
      direction="column"
      align="center"
      h="100%"
      justify="center"
      gap={16}
      pt={16}
    >
      <Image width={80} height={80} src={loaderGif} alt="Loading..." />
      <Text align="center">
        Processing Document, please refresh page or
        <br></br>
        click refresh button to show the result
      </Text>
    </Flex>
  );
};
